import { inject, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Data } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { AlarisAuthService, AlarisProfileService, PROFILE_SERVICE_INJECTOR } from '@campaign-portal/components-library';

@Injectable()
export class AuthGuardService {
	readonly currentRouteData = new BehaviorSubject<Data | null>(null);
	readonly parentRoute = new BehaviorSubject<ActivatedRouteSnapshot | null>(null);

	constructor(
		private readonly authService: AlarisAuthService,
		@Inject(PROFILE_SERVICE_INJECTOR) private readonly profile: AlarisProfileService
	) {}

	canActivate(route: ActivatedRouteSnapshot): boolean {
		if (this.authService.logged) {
			this.currentRouteData.next(route.data);
			this.parentRoute.next(route.parent);
			if (route.data.permissions) {
				return this.profile.allowed(route.data.permissions, route.data.permissionComparison ?? 'every');
			}
			return true;
		}

		this.currentRouteData.next(null);
		this.parentRoute.next(null);
		this.authService.logOut();
		return false;
	}
}

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean =>
	inject(AuthGuardService).canActivate(route);
